<template>
    <b-container fluid v-if="firebaseDoctor">
      <b-row>
        <b-col lg="4">
          <iq-card body-class="iq-card-body pl-0 pr-0 pt-0">
            <template v-slot:default>
              <div class="docter-details-block">
                <div class="doc-profile-bg bg-primary" style="height:150px;">
                </div>
                <div class="docter-profile text-center" v-if="user && user.profilePic">
                  <b-img :src="user.profilePic" alt="profile-img" class="profile-pic" />
                </div>
                <div class="docter-profile text-center" v-else>
                  <b-img :src="defaultProfilePic" alt="profile-img" class="profile-pic" />
                </div>
                <div class="text-center mt-3 pl-3 pr-3">
                  <h4><b> {{ firebaseDoctor.displayName }} </b></h4>
                  <p>Patient</p>
                </div>
              </div>
            </template>
          </iq-card>
          <iq-card body-class="iq-card-body">
            <template v-slot:default>
              <div class="iq-card-header d-flex justify-content-between">
                <div class="iq-header-title">
                  <h4 class="card-title">Personal Information</h4>
                </div>
              </div>
              <div class="iq-card-body">
                <div class="about-info m-0 p-0">
                  <div class="row">
                    <div class="col-4">First Name:</div>
                    <div class="col-8">{{ firebaseDoctor.displayName.split(" ")[0] }}</div>
                    <div class="col-4">Last Name:</div>
                    <div class="col-8">{{ firebaseDoctor.displayName.split(" ")[1] }}</div>
                    <div class="col-4">Email:</div>
                    <div class="col-8">{{ firebaseDoctor.email }}</div>
                    <div class="col-4">Phone:</div>
                    <div class="col-8">{{ firebaseDoctor.phoneNumber }}</div>
                  </div>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="8">
          <b-row>
            <b-col md="12">
              <iq-card>
                <template v-slot:headerTitle>
                  <h4 class="card-title">Notifications</h4>
                </template>
                <template v-slot:default>
                <div v-if="firebaseDoctor.notifications">
                  <ul class="iq-timeline">
                    <li>
                      <div class="timeline-dots border-success"></div>
                      <h6 class="">Dr. Joy Send you Photo</h6>
                      <small class="mt-1">23 November 2019</small>
                    </li>
                  </ul>
                </div>
                <div v-else>No notifications.</div>
                </template>
              </iq-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </template>
<script>
import { xray } from '../../config/pluginInit'
import firebaseService from '../../../firebase'
import getDocument from '../../services/getDocument'

export default {
  name: 'ProfileView',
  mounted () {
    xray.index()
  },
  setup () {
    const firebaseUser = firebaseService.firebaseAuth.currentUser
    const defaultProfilePic = require('../../assets/images/user/11.png')

    const { document: user } = getDocument('users', firebaseUser.uid)

    return { defaultProfilePic, firebaseDoctor: firebaseUser, user }
  }
}
</script>

  <style scoped>
    .profile-pic{
      height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
      margin: auto;
    }

    .removeBtn {
      color: #b583bc;
    }
  </style>
